import api from 'api';
import { EVENTS } from '../Users.config';

export const getEventName = name => `data_${name}`;
export const getEventSort = name => `sort_${name}`;

const addEventData = (state) => {
  const defaultState = { ...state };
  for (const eventKey of Object.keys(EVENTS)) defaultState[getEventName(eventKey)] = null;
  return defaultState;
};

const addSortData = (state) => {
  const defaultState = { ...state };
  for (const eventKey of Object.keys(EVENTS)) {
    const event = EVENTS[eventKey];
    if (event.defaultSort) defaultState[getEventSort(eventKey)] = event.defaultSort;
  }

  return defaultState;
};

export const createDefaultState = (baseState) => {
  let defaultState = { ...baseState };
  defaultState = addEventData(defaultState);
  defaultState = addSortData(defaultState);

  return defaultState;
};

export const getFetchFunction = type => {
  switch (type) {
    case EVENTS.pageviews.id:
      return api.getPageViews;
    case EVENTS.sessions.id:
      return api.getSessions;
    case EVENTS.clicks.id:
      return api.getClicks;
    case EVENTS.form_interactions.id:
      return api.getFormInteractions;
    default:
      throw new Error('getFetchFunction - wrong type');
  }
};

export const cancelRequest = request => {
  try {
    request.cancel('canceled');
  } catch (error) {
    console.log('error');
  }
};



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/Details/config.js